"use client"

import styled from "styled-components"
import {
  Card,
  CardHeader,
  List,
  Row,
  RowInfo,
  RowMeta,
  RowName,
  Subtitle,
  Title,
  TitleGroup,
} from "./primitives"

const filings = [
  { form: "10-K", title: "Annual report", date: "Jan 12, 2026", tone: "optimal" as const },
  { form: "8-K", title: "Material agreement", date: "Jan 09, 2026", tone: "caution" as const },
  { form: "4", title: "Insider: CFO sale", date: "Jan 07, 2026", tone: "alert" as const },
  { form: "10-Q", title: "Quarterly report", date: "Dec 28, 2025", tone: "optimal" as const },
]

const toneColor = {
  optimal: "var(--color-optimal)",
  caution: "var(--color-caution)",
  alert: "var(--color-alert)",
}

const FormTag = styled.span<{ $tone: keyof typeof toneColor }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 3rem;
  padding: 0.375rem 0.5rem;
  border-radius: 0.625rem;
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--color-card-foreground);
  background: ${(p) => `color-mix(in oklch, ${toneColor[p.$tone]} 20%, transparent)`};
  border: 1px solid ${(p) => `color-mix(in oklch, ${toneColor[p.$tone]} 45%, transparent)`};
`

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
`

export function FilingsCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Recent SEC filings</Title>
          <Subtitle>EDGAR full-text feed</Subtitle>
        </TitleGroup>
      </CardHeader>

      <List>
        {filings.map((f) => (
          <Row key={f.form + f.date}>
            <LeftGroup>
              <FormTag $tone={f.tone}>{f.form}</FormTag>
              <RowInfo>
                <RowName>{f.title}</RowName>
                <RowMeta>Filed {f.date}</RowMeta>
              </RowInfo>
            </LeftGroup>
          </Row>
        ))}
      </List>
    </Card>
  )
}

export default FilingsCard
